<template>
    <div>
        <h3>STEP 2. PIMPINAN</h3>
        <em>
            <b>Pimpinan Badan Usaha</b> adalah Pimpinan tertinggi dari Badan Usaha
            berupa Direktur, Direktur Utama, Ketua dan lain-lain.
        </em>
        <div class="my-4">
            <form
                @submit.prevent="
                    editMode ? update(helper.pimpinan_id) : store()
                "
                @keydown="form.onKeydown($event)"
                autocomplete="off"
            >
                <b-card>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >NIK <span class="text-danger">*</span></label
                        >
                        <div class="col-md-5">
                            <div class="row">
                                <div class="col-sm-12">
                                    <input
                                        type="text"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid': helper.errors.hasOwnProperty(
                                                'nik'
                                            )
                                        }"
                                        placeholder="Masukkan NIK"
                                        v-model="form.nik"
                                        :disabled="isLoading"
                                    />
                                    <em
                                        v-if="
                                            helper.errors.hasOwnProperty('nik')
                                        "
                                        class="form-text text-danger"
                                        >{{ helper.errors.nik[0] }}</em
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >NAMA <span class="text-danger">*</span></label
                        >
                        <div class="col-md-5">
                            <div class="row">
                                <div class="col-sm-12">
                                    <input
                                        type="text"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid': helper.errors.hasOwnProperty(
                                                'nama'
                                            )
                                        }"
                                        placeholder="Masukkan Nama"
                                        v-model="form.nama"
                                        :disabled="isLoading"
                                        style="text-transform: uppercase;"
                                    />
                                    <em
                                        v-if="
                                            helper.errors.hasOwnProperty('nama')
                                        "
                                        class="form-text text-danger"
                                        >{{ helper.errors.nama[0] }}</em
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >JABATAN <span class="text-danger">*</span></label
                        >
                        <div class="col-md-5">
                            <div class="row">
                                <div class="col-sm-12">
                                    <input
                                        type="text"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid': helper.errors.hasOwnProperty(
                                                'jabatan'
                                            )
                                        }"
                                        placeholder="Masukkan Jabatan"
                                        v-model="form.jabatan"
                                        :disabled="isLoading"
                                    />
                                    <em
                                        v-if="
                                            helper.errors.hasOwnProperty(
                                                'jabatan'
                                            )
                                        "
                                        class="form-text text-danger"
                                        >{{ helper.errors.jabatan[0] }}</em
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </b-card>
                <div class="font-weight-bold my-3">
                    <h3>KONTAK & ALAMAT</h3>
                </div>
                <b-card class="my-3">
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >NO. HANDPHONE
                            <span class="text-danger">*</span></label
                        >
                        <div class="col-md-5">
                            <div class="row">
                                <div class="col-sm-12">
                                    <input
                                        type="text"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid': helper.errors.hasOwnProperty(
                                                'nomp'
                                            )
                                        }"
                                        placeholder="Masukkan Nomor Handphone"
                                        v-model="form.nomp"
                                        :disabled="isLoading"
                                    />
                                    <em
                                        v-if="
                                            helper.errors.hasOwnProperty('nomp')
                                        "
                                        class="form-text text-danger"
                                        >{{ helper.errors.nomp[0] }}</em
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >NO. TELEPON</label
                        >
                        <div class="col-md-5">
                            <div class="row">
                                <div class="col-sm-12">
                                    <input
                                        type="text"
                                        :class="{
                                            'form-control': true
                                        }"
                                        placeholder="Masukkan Nomor Telepon"
                                        v-model="form.notelepon"
                                        :disabled="isLoading"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >EMAIL <span class="text-danger">*</span></label
                        >
                        <div class="col-md-5">
                            <div class="row">
                                <div class="col-sm-12">
                                    <input
                                        type="text"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid': helper.errors.hasOwnProperty(
                                                'email'
                                            )
                                        }"
                                        placeholder="Masukkan Email"
                                        v-model="form.email"
                                        :disabled="isLoading"
                                    />
                                    <em
                                        v-if="
                                            helper.errors.hasOwnProperty(
                                                'email'
                                            )
                                        "
                                        class="form-text text-danger"
                                        >{{ helper.errors.email[0] }}</em
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >ALAMAT <span class="text-danger">*</span></label
                        >
                        <div class="col-md-5">
                            <div class="row">
                                <div class="col-sm-12">
                                    <input
                                        type="text"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid': helper.errors.hasOwnProperty(
                                                'email'
                                            )
                                        }"
                                        placeholder="Masukkan Alamat"
                                        :disabled="isLoading"
                                        v-model="form.alamat"
                                    />
                                    <em
                                        v-if="
                                            helper.errors.hasOwnProperty(
                                                'alamat'
                                            )
                                        "
                                        class="form-text text-danger"
                                        >{{ helper.errors.alamat[0] }}</em
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >PROVINSI <span class="text-danger">*</span></label
                        >
                        <div class="col-md-4">
                            <div class="row">
                                <div class="col-sm-12">
                                    <v-select
                                        label="nama"
                                        :reduce="nama => nama.id"
                                        :class="{'style-chooser': helper.errors.hasOwnProperty('wilayah_kelurahan_id')}"
                                        :options="Wilayah.provinsi"
                                        v-model="wilayah.provinsi"
                                        @input="onProvinsi(wilayah.provinsi)"
                                        placeholder="Pilih Provinsi"
                                        :disabled="isLoading"
                                    >
                                    </v-select>
                                    <em
                                        v-if="
                                            helper.errors.hasOwnProperty(
                                                'wilayah_kelurahan_id'
                                            )
                                        "
                                        class="form-text text-danger"
                                        >Bagian isian Provinsi wajib diisi.</em
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >KAB./KOTA <span class="text-danger">*</span></label
                        >
                        <div class="col-md-4">
                            <div class="row">
                                <div class="col-sm-12">
                                    <v-select
                                        label="nama"
                                        :reduce="nama => nama.id"
                                        :options="Wilayah.kabkota"
                                        :class="{'style-chooser': helper.errors.hasOwnProperty('wilayah_kelurahan_id')}"
                                        v-model="wilayah.kabkota"
                                        @input="onKabkota(wilayah.kabkota)"
                                        placeholder="Pilih Kab./Kota"
                                        :disabled="isLoading"
                                    >
                                    </v-select>
                                    <em
                                        v-if="
                                            helper.errors.hasOwnProperty(
                                                'wilayah_kelurahan_id'
                                            )
                                        "
                                        class="form-text text-danger"
                                        >Bagian isian Kab./Kota wajib diisi.</em
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >KECAMATAN <span class="text-danger">*</span></label
                        >
                        <div class="col-md-4">
                            <div class="row">
                                <div class="col-sm-12">
                                    <v-select
                                        label="nama"
                                        :reduce="nama => nama.id"
                                        :options="Wilayah.kecamatan"
                                        :class="{'style-chooser': helper.errors.hasOwnProperty('wilayah_kelurahan_id')}"
                                        v-model="wilayah.kecamatan"
                                        @input="onKecamatan(wilayah.kecamatan)"
                                        placeholder="Pilih Kecamatan"
                                        :disabled="isLoading"
                                    >
                                    </v-select>
                                    <em
                                        v-if="
                                            helper.errors.hasOwnProperty(
                                                'wilayah_kelurahan_id'
                                            )
                                        "
                                        class="form-text text-danger"
                                        >Bagian isian Kecamatan wajib diisi.</em
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >KELURAHAN <span class="text-danger">*</span></label
                        >
                        <div class="col-md-4">
                            <div class="row">
                                <div class="col-sm-12">
                                    <v-select
                                        label="nama"
                                        :reduce="nama => nama.id"
                                        :options="Wilayah.kelurahan"
                                        :class="{'style-chooser': helper.errors.hasOwnProperty('wilayah_kelurahan_id')}"
                                        v-model="form.wilayah_kelurahan_id"
                                        placeholder="Pilih Kelurahan"
                                        :disabled="isLoading"
                                    >
                                    </v-select>
                                    <em
                                        v-if="
                                            helper.errors.hasOwnProperty(
                                                'wilayah_kelurahan_id'
                                            )
                                        "
                                        class="form-text text-danger"
                                        >{{ helper.errors.wilayah_kelurahan_id[0] }}</em
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >KODEPOS <span class="text-danger">*</span></label
                        >
                        <div class="col-md-4">
                            <div class="row">
                                <div class="col-sm-12">
                                    <input
                                        type="text"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid': helper.errors.hasOwnProperty('kodepos')
                                        }"
                                        v-model="form.kodepos"
                                        placeholder="Masukkan Kodepos"
                                        :disabled="isLoading"
                                    />
                                    <em
                                        v-if="
                                            helper.errors.hasOwnProperty(
                                                'kodepos'
                                            )
                                        "
                                        class="form-text text-danger"
                                        >{{ helper.errors.kodepos[0] }}</em
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </b-card>
                <div>
                    <b-row>
                        <b-col>
                            <b-button variant="primary" type="submit">
                                <b-spinner variant="light" label="Spinning" small v-if="isLoading"></b-spinner>
                                <span v-else>
                                    <i class="fa fa-edit" v-if="editMode"></i>
                                    <i class="fa fa-save" v-else></i>
                                </span>
                                <span v-if="editMode">
                                    Edit
                                </span>
                                <span v-else>
                                    Simpan
                                </span>
                            </b-button>
                        </b-col>
                        <b-col>
                            <div class="float-right">
                                <span class="mx-2">
                                    <b-button variant="danger" @click="prevButton">
                                        <i class="fa fa-arrow-left"></i>
                                        Sebelumnya
                                    </b-button>
                                </span>
                                <span>
                                    <b-button variant="success" @click="nextButton" :disabled="helper.buttonDisabled">
                                        Selanjutnya
                                        <i class="fa fa-arrow-right"></i>
                                    </b-button>
                                </span>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
// eslint-disable-next-line
// eslint-disable vue/no-unused-vars
// eslint-disable-line no-unused-vars
import npbuWakilMixins from "@/helper/npbu/npbu_wakil";
import { mapState } from "vuex";
import wilayahMixins from "@/helper/wilayah/wilayah";

export default {
    mixins: [npbuWakilMixins, wilayahMixins],
    data() {
        return {
            // vform variable
            form: new Form({
                npbu_id: "",
                nik: "",
                nama: "",
                nomp: "",
                notelepon: "",
                email: "",
                alamat: "",
                wilayah_kelurahan_id: "",
                kodepos: "",
                jabatan: "",
                status_sk: "",
                no_sk: "",
                tgl_sk: "",
                dok_sk: "",
                aktif: ''
            }),
            // helper variable
            helper: {
                errors: "",
                npbu_id: JSON.parse(localStorage.getItem("npbu_id")),
                buttonDisabled: true,
                status_sk: 1,
                pimpinan_id: ''
            },
            wilayah: {
                provinsi: "",
                kecamatan: "",
                kabkota: ""
            },
            // edit mode
            editMode: false,
            isLoading: false
        };
    },
    computed: {
        ...mapState(["Wilayah"])
    },
    mounted() {
        // vuex - call data wilayah provinsi
        this.$store.dispatch("Wilayah/getProvinsi");
        // mixin - call data npbu
        if (this.helper.npbu_id) {
            this.getDetailNpbu(this.helper.npbu_id)
        }
    },
    methods: {
        // kembali ke step 1
        prevButton() {
            this.$router.push({ name: 'Profil' })
        },
        // lanjut ke step 3
        nextButton () {
            this.$router.push({ name: 'PenanggungJawab' })
        }
    }
};
</script>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
    border-color: red;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
    fill: #394066;
}
</style>
